import { render, staticRenderFns } from "./LoanOverview.vue?vue&type=template&id=f44e0ede&scoped=true&"
import script from "./LoanOverview.vue?vue&type=script&lang=js&"
export * from "./LoanOverview.vue?vue&type=script&lang=js&"
import style0 from "./LoanOverview.vue?vue&type=style&index=0&id=f44e0ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44e0ede",
  null
  
)

export default component.exports